import { EVENT_GROUPS_KEY } from './constants';

export function loadEventGroups() {
  try {
    const raw = localStorage.getItem(EVENT_GROUPS_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveEventGroups(groups) {
  localStorage.setItem(EVENT_GROUPS_KEY, JSON.stringify(groups));
}
